import { Component, input } from '@angular/core';
import {MinutesToHoursPipe} from '../../../../shared/pipes/minutes-to-hours.pipe';
import {CurrencyPipe} from '@angular/common';
import {TotalsDto} from '../../../../api';

@Component({
  selector: 'app-reports-summary-header',
  standalone: true,
  imports: [MinutesToHoursPipe, CurrencyPipe],
  templateUrl: './reports-summary-header.component.html',
  styleUrl: './reports-summary-header.component.css',
})
export class ReportsSummaryHeaderComponent {
  totals = input.required<TotalsDto>();
}
